import { createAction, props } from '@ngrx/store';
export const setTabs = createAction('[Custom PDF Report Builder] Set Tabs', props());
export const setIsEdited = createAction('[Custom PDF Report Builder] Set Is Edited', props());
